import {
  LOGS_REVIEW_CHATBOT_DETAILS, LOGS_REVIEW_AUTHERAI_SELECT, LOGS_REVIEW_SELECTED_PRODUCT, SEARCH_FILTER,
  LOGS_REVIEW_PAGINATION_TAKE, LOGS_REVIEW_PAGINATION_PAGE, TOTAL_PAGE_COUNT, LOGS_REVIEW_TOTAL_QUERY_COUNT,
  LOGS_REVIEW_TABLE_DATA, LOGS_REVIEW_CHART_DATA, LOGS_REVIEW_TABLE_LOADING,
  LOGS_REVIEW_QUERY_ID, RESPONSE_CONVERSATION_STEP, LOGS_REVIEW_ASK_YOUR_DATA_SELECT, FEEDBACK_FILTER,
  SET_QUERY_SELECTED_TAB,REJECT_REASON
} from '../../common/actionTypes';

const INITIAL_STATE = {
  logsReviewChatbotDetails: null,
  logsReviewAuthorAIselect: null,
  logsReviewAskYourDataselected: null,
  logReviewSelectedProduct: null,
  serachFilter: null,
  logsReviewPaginationTake: null,
  logsReviewPaginationPage: 1,
  logsReviewTotalPageCount: 0,
  logsReviewTotalQueryCount: 0,
  logsReviewTableData: null,
  logsReviewChartData: null,
  logsReviewTableLoading: true,
  logsReviewQueryId: null,
  responseConversationStep: null,
  feedbackFilter: null,
  reasonFilter:null,
  tabSelected: '',
};

const LogsReviewDataReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case LOGS_REVIEW_CHATBOT_DETAILS: {
      return {
        ...state,
        logsReviewChatbotDetails: action.payload,
      };
    }
    case LOGS_REVIEW_ASK_YOUR_DATA_SELECT: {
      return {
        ...state,
        logsReviewAskYourDataselected: action.payload,
      };
    }
    case LOGS_REVIEW_AUTHERAI_SELECT: {
      return {
        ...state,
        logsReviewAuthorAIselect: action.payload,
      };
    }
    case LOGS_REVIEW_SELECTED_PRODUCT: {
      return {
        ...state,
        logReviewSelectedProduct: action.payload,
      };
    }
    case SEARCH_FILTER: {
      return {
        ...state,
        serachFilter: action.payload,
      };
    }
    case LOGS_REVIEW_PAGINATION_TAKE: {
      return {
        ...state,
        logsReviewPaginationTake: action.payload,
      };
    }
    case LOGS_REVIEW_PAGINATION_PAGE: {
      return {
        ...state,
        logsReviewPaginationPage: action.payload,
      };
    }
    case TOTAL_PAGE_COUNT: {
      return {
        ...state,
        logsReviewTotalPageCount: action.payload,
      };
    }
    case LOGS_REVIEW_TOTAL_QUERY_COUNT: {
      return {
        ...state,
        logsReviewTotalQueryCount: action.payload,
      };
    }
    case LOGS_REVIEW_TABLE_DATA: {
      return {
        ...state,
        logsReviewTableData: action.payload,
      };
    }
    case LOGS_REVIEW_CHART_DATA: {
      return {
        ...state,
        logsReviewChartData: action.payload,
      };
    }
    case LOGS_REVIEW_TABLE_LOADING: {
      return {
        ...state,
        logsReviewTableLoading: action.payload,
      };
    }
    case LOGS_REVIEW_QUERY_ID: {
      return {
        ...state,
        logsReviewQueryId: action.payload,
      };
    }
    case RESPONSE_CONVERSATION_STEP: {
      return {
        ...state,
        responseConversationStep: action.payload,
      };
    }
    case FEEDBACK_FILTER: {
      return {
        ...state,
        feedbackFilter: action.payload,
      };
    }
    case REJECT_REASON: {
      return {
        ...state,
        reasonFilter: action.payload,
      };
    }
    case SET_QUERY_SELECTED_TAB: {
      return {
        ...state,
        tabSelected: action.payload,
      };
    }
    default:
      return state;
  }
};

export default LogsReviewDataReducer;
